import React from "react";
import "./EdusifyStory__filkename.css";

const EdusifyStory__filkename = () => {
  return (
    <div className="storyContainer__filkename">
      <div className="storyContent__filkename">
        <h1 className="storyTitle__filkename">How Edusify Was Made</h1>

        {/* Introduction */}
        <h2 className="storySectionTitle__filkename">The Vision – Why Edusify Was Created</h2>
        <p className="storyText__filkename">
          **Not every study app is made equal.**  
          Some are clunky. Some are outdated. And most? Just distractions.  
        </p>
        <p className="storyText__filkename">
          Edusify was built differently. A **high-end, AI-powered study app**  
          designed for students who **take their future seriously**.  
        </p>
        <p className="storyText__filkename">
          This isn’t just another tool.  
          It’s the **Apple of study apps**—crafted for those who demand the best.  
        </p>

        {/* How It Started */}
        <h2 className="storySectionTitle__filkename">The Beginning – A Solo Founder’s Journey</h2>
        <p className="storyText__filkename">
          **I built Edusify alone.**  
          No team. No investors. Just a **vision** and an obsession to create  
          the **ultimate** study experience.  
        </p>
        <p className="storyText__filkename">
          From a small room in **Bangalore**, I designed, coded, and perfected  
          every detail. **Every line of code, every UI animation, every AI algorithm**—  
          all made by me.  
        </p>
        <p className="storyText__filkename">
          Other apps? Built by companies trying to **profit off students**.  
          Edusify? Built by someone who **actually understands students**.  
        </p>

        {/* Growth */}
        <h2 className="storySectionTitle__filkename">The Growth – 0 to 155K Users in 6 Months 🚀</h2>
        <p className="storyText__filkename">
          Edusify didn’t need ads. **Word spread fast.**  
          Students realized it wasn’t just another app—it was a **study revolution**.  
        </p>
        <p className="storyText__filkename">
          **Why do toppers use Edusify?**  
          Because it’s built for **serious learners**—students who **want more**.  
        </p>
        <p className="storyText__filkename">
          <strong>🔹 AI-Powered Study Tools →</strong> Smart flashcards, personalized Pomodoro,  
          and AI-generated quizzes that **think for you**.  
        </p>
        <p className="storyText__filkename">
          <strong>🔹 Premium, Distraction-Free UI →</strong> Designed to keep you focused  
          without **wasting time on cluttered apps**.  
        </p>
        <p className="storyText__filkename">
          <strong>🔹 Real-World Impact →</strong> Top students, medical aspirants, and  
          competitive exam toppers **trust Edusify every day**.  
        </p>
        <p className="storyText__filkename">
          <strong>0 to 155K users in 6 months.</strong> And every single one?  
          **Students who know the value of smart studying.**  
        </p>

        {/* PsySlogy Persuasion Section */}
        <h2 className="storySectionTitle__filkename">Why You Need Edusify – The Future of Smart Studying</h2>
        <p className="storyText__filkename">
          **Let’s be real.**  
          If you’re serious about success, you need **the best tools**.  
        </p>
        <p className="storyText__filkename">
          Imagine **studying 30% faster, remembering more, and staying 100% focused**—  
          all because your app actually works **with** you, not against you.  
        </p>
        <p className="storyText__filkename">
          <strong>That’s Edusify.</strong> The AI-powered study app built for  
          students who **demand more from themselves**.  
        </p>
        <p className="storyText__filkename">
          <strong>🚀 Toppers already use it.</strong> Now it’s your turn.  
          **Get Edusify today.**  
        </p>

        {/* The Future */}
        <h2 className="storySectionTitle__filkename">The Future – Edusify is Just Getting Started</h2>
        <p className="storyText__filkename">
          The journey doesn’t stop at **155K users**.  
          Edusify is on its way to being **the #1 study app in the world**.  
        </p>
        <p className="storyText__filkename">
          The goal? **To be on every student’s phone.** Just like WhatsApp.  
        </p>
        <p className="storyText__filkename">
          But this isn’t just an app. **It’s a movement.**  
          A new era of **smart, distraction-free studying.**  
        </p>
        <p className="storyText__filkename">
          <strong>Next up?</strong> AI-powered breakthroughs, deeper learning tools, and  
          **Edusify’s domination in EdTech.**  
        </p>
      </div>
    </div>
  );
};

export default EdusifyStory__filkename;
